var map = {
	"./banescale.png": 59,
	"./bogsneak.png": 60,
	"./coatl.png": 61,
	"./fae.png": 62,
	"./gaoler.png": 63,
	"./guardian.png": 64,
	"./imperial.png": 65,
	"./mirror.png": 66,
	"./nocturne.png": 67,
	"./obelisk.png": 68,
	"./pearlcatcher.png": 69,
	"./ridgeback.png": 70,
	"./skydancer.png": 71,
	"./snapper.png": 72,
	"./spiral.png": 73,
	"./tundra.png": 74,
	"./veilspun.png": 75,
	"./wildclaw.png": 76
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58;